/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AcquisitionAndReactivationReprocess {
  amount?: number;
  authorizationMessage?: string;
  creditCardPaymentId?: number;
  dateCreated?: Date;
  email?: string;
  nameType?: string;
  nome?: string;
  personId?: number;
  phone?: string;
  plano?: string;
  subscriberId?: number;
  subscriptionName?: string;
  tid?: string;
  transactionStatusId?: number;
}
